import WebfilingSearchSection from 'src/components/section/WebfilingSearchSection';
import Footer from 'src/components/layout/Footer';
import Header from 'src/components/page/Header';
import { Box } from '@mui/material';
import AdminAuthContext from 'src/store/admin-auth-context';
import { useContext } from 'react';
const AdminHome = () => {
  const { logout } = useContext(AdminAuthContext);
  return (
    <>
      <Header onLogout={logout} />

      <Box
        sx={{
          mt: '1rem',
          mx: 'auto',
          maxWidth: '80vw',
        }}
      >
        <WebfilingSearchSection />
      </Box>

      <Footer />
    </>
  );
};

export default AdminHome;
